import { AuthenticationException } from './authentication-exception';

export class AccountLockedException extends AuthenticationException { }
